(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["production"] = factory();
	else
		root["production"] = factory();
})(this, function() {
return webpackJsonp_name_([1],{

/***/ 22:
/* no static exports found */
/* all exports used */
/*!********************************!*\
  !*** ./styles/production.scss ***!
  \********************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 54:
/* no static exports found */
/* all exports used */
/*!**********************************!*\
  !*** ./images/production-bg.jpg ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "/media/images/production-bg.jpg";

/***/ }),

/***/ 55:
/* no static exports found */
/* all exports used */
/*!**************************************!*\
  !*** ./images/production-item-1.jpg ***!
  \**************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "/media/images/production-item-1.jpg";

/***/ }),

/***/ 56:
/* no static exports found */
/* all exports used */
/*!**************************************!*\
  !*** ./images/production-item-2.jpg ***!
  \**************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "/media/images/production-item-2.jpg";

/***/ }),

/***/ 57:
/* no static exports found */
/* all exports used */
/*!******************************************!*\
  !*** ./images/production-masonry-bg.jpg ***!
  \******************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "/media/images/production-masonry-bg.jpg";

/***/ }),

/***/ 58:
/* no static exports found */
/* all exports used */
/*!****************************************!*\
  !*** ./images/production-nmarksbg.jpg ***!
  \****************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "/media/images/production-nmarksbg.jpg";

/***/ }),

/***/ 59:
/* no static exports found */
/* all exports used */
/*!****************************************!*\
  !*** ./images/production-omcarbbg.jpg ***!
  \****************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "/media/images/production-omcarbbg.jpg";

/***/ }),

/***/ 65:
/* no static exports found */
/* all exports used */
/*!********************************!*\
  !*** ./images/use-bg-1-en.jpg ***!
  \********************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "/media/images/use-bg-1-en.jpg";

/***/ }),

/***/ 66:
/* no static exports found */
/* all exports used */
/*!********************************!*\
  !*** ./images/use-bg-1-ru.jpg ***!
  \********************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "/media/images/use-bg-1-ru.jpg";

/***/ }),

/***/ 67:
/* no static exports found */
/* all exports used */
/*!********************************!*\
  !*** ./images/use-bg-2-en.jpg ***!
  \********************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "/media/images/use-bg-2-en.jpg";

/***/ }),

/***/ 68:
/* no static exports found */
/* all exports used */
/*!********************************!*\
  !*** ./images/use-bg-2-ru.jpg ***!
  \********************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "/media/images/use-bg-2-ru.jpg";

/***/ }),

/***/ 75:
/* no static exports found */
/* all exports used */
/*!***********************!*\
  !*** ./production.js ***!
  \***********************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(/*! ./styles/production */ 22);

__webpack_require__(/*! ./images/production-item-1.jpg */ 55);

__webpack_require__(/*! ./images/production-item-2.jpg */ 56);

__webpack_require__(/*! ./images/production-bg.jpg */ 54);

__webpack_require__(/*! ./images/production-nmarksbg.jpg */ 58);

__webpack_require__(/*! ./images/production-omcarbbg.jpg */ 59);

__webpack_require__(/*! ./images/production-masonry-bg.jpg */ 57);

__webpack_require__(/*! ./images/use-bg-1-ru.jpg */ 66);

__webpack_require__(/*! ./images/use-bg-1-en.jpg */ 65);

__webpack_require__(/*! ./images/use-bg-2-ru.jpg */ 68);

__webpack_require__(/*! ./images/use-bg-2-en.jpg */ 67);

var _barba = __webpack_require__(/*! barba.js */ 2);

var _barba2 = _interopRequireDefault(_barba);

var _jquery = __webpack_require__(/*! jquery */ 0);

var _jquery2 = _interopRequireDefault(_jquery);

var _common = __webpack_require__(/*! ./common */ 1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function productionOn() {
    if ((0, _jquery2.default)('.production-carbon__slide').length) {
        addWidthCarbon();
    }
    (0, _jquery2.default)('a[href*="#"]:not([href="#"])').on('click', function () {
        var target = (0, _jquery2.default)(this.hash);
        target = target.length ? target : (0, _jquery2.default)('[name=' + this.hash.substr(1) + ']');
        if (target.length) {
            _common.$htmlBody.animate({
                scrollTop: target.offset().top
            }, 1000);
            return false;
        }
    });

    function addWidthCarbon() {
        var result = 0;
        (0, _jquery2.default)('.production-carbon__slide').each(function (i, item) {
            var width = (0, _jquery2.default)(item).width();
            if (width > result) {
                result = width;
                (0, _jquery2.default)(this).parent().css('width', result);
            }
        });
    }

    (0, _jquery2.default)(window).on('resize', addWidthCarbon);

    function animateCarbon(direction) {
        var $items = (0, _jquery2.default)('.production-carbon__slide');
        var $active = (0, _jquery2.default)('.production-carbon__slide.is-active');
        var l = $items.length - 1;
        var index = $items.index($active);

        if (direction === 'next') {
            if (index >= l) index = 0;else index++;
        } else if (direction === 'prev') {
            if (!index) index = l;else index--;
        }

        $active.removeClass('is-active');
        (0, _jquery2.default)($items[index]).addClass('is-active');
    }

    (0, _jquery2.default)('.mark__head').on('click', function (e) {
        var $target = (0, _jquery2.default)(e.target);
        var $mark = (0, _jquery2.default)(this).parent();
        var ACTIVE = 'is-active';

        if (!$target.hasClass('mark__text_docs')) {
            if (!$mark.hasClass(ACTIVE) && $mark.children('.mark__more').length) {
                $mark.addClass(ACTIVE);
            } else {
                $mark.removeClass(ACTIVE);
            }
        }
    });

    setInterval(function () {
        animateCarbon('next');
    }, 3000);
}

(0, _jquery2.default)(function () {
    !_common.isFirst || productionOn();
});

var Production = _barba2.default.BaseView.extend({
    namespace: 'production',

    onEnter: function onEnter() {
        //console.log('Новый контейнер готов и прикреплен к dom.')
        productionOn();
    },
    onEnterCompleted: function onEnterCompleted() {
        //console.log('Переход закончился.')
    },
    onLeave: function onLeave() {
        //console.log('Новый переход к новой странице только начался.')
        _common.$html.off('keydown.barbaView');
    },
    onLeaveCompleted: function onLeaveCompleted() {
        //console.log('Контейнер был удален из dom.')
    }
});

Production.init();

/***/ })

},[75]);
});


// WEBPACK FOOTER //
// js/production.js